import styled from 'styled-components';

const Asterisk = styled.div`
    color: var(--error-default);
    padding-right: 0.4rem;
`;

export function RequiredMessage() {
    return (
        <div className="flex">
            <Asterisk>*</Asterisk>Required
        </div>
    );
}
